.container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    min-height: 26px;
    color: var(--blue);
    user-select: none;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid var(--off-white-dk);
    background-color: var(--yellow-lt);
    flex-shrink: 0;
}

.header {
    display: flex;
    flex-grow: 1;
    align-items: center;
    padding: 4px 0;
    cursor: pointer;
}

.container:hover .header {
    color: var(--blue-dk);
}

.sort-toggle {
    background: transparent;
    border: none;
    color: var(--grey);
    cursor: pointer;
    display: flex;
    gap: 4px;
    align-items: center;
    transition:
        background-color 0.2s,
        color 0.2s;
    border-radius: 4px;

    svg {
        margin-top: 4px;
    }
}

.sort-toggle:hover {
    svg {
        color: var(--blue);
    }
    background-color: rgba(0, 0, 0, 0.05);
}

.container-open {
    composes: container;
    border-bottom: none;
}

.left-section {
    font-size: var(--font-small);
    cursor: pointer;
}

.left-section .chevron-icon {
    font-size: 11px;
    color: var(--grey);
    width: 15px; /* So the text doesn't jump when changing from chevron icon right to chevron icon down */
    display: inline-block;
}

.container-open .left-section .chevron-icon {
    position: relative;
    top: -1px;
}

.count {
    color: var(--grey);
    margin-left: 5px;
}
